import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/block_black.svg'
import _imports_2 from '@/assets/img/chat/chatRequest_on.svg'
import _imports_3 from '@/assets/img/profile/user.png'
import _imports_4 from '@/assets/img/profile/star.png'
import _imports_5 from '@/assets/img/profile/categories.png'
import _imports_6 from '@/assets/img/profile/calendar.png'
import _imports_7 from '@/assets/img/profile/orders.png'
import _imports_8 from '@/assets/img/profile/lock.png'
import _imports_9 from '@/assets/img/profile/denied.png'
import _imports_10 from '@/assets/img/profile/close_circled.png'
import _imports_11 from '@/assets/img/profile/logout.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-72377428")

_pushScopeId("data-v-72377428")
const _hoisted_1 = {
  key: 0,
  class: "header d-flex align-items-center justify-content-between"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_6 = { class: "fs_22 spaceCadet text-center d-block mt-2 mb-1" }
const _hoisted_7 = { class: "fs_14 greyBlue text-center text-break-word" }
const _hoisted_8 = { class: "d-flex justify-content-around mt-4" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = {
  key: 0,
  class: "listButtonContainer mt-5"
}
const _hoisted_12 = {
  key: 0,
  class: "pallinoNotifiche"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "pallinoNotifiche"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("img", { src: _imports_8 }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", { src: _imports_9 }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", { src: _imports_10 }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("img", { src: _imports_11 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_profile_image = _resolveComponent("user-profile-image")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.profile)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["genericPadding hasFooter", !_ctx.isSelf ? 'hasHeader' : '']
      }, [
        (!_ctx.isSelf)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", {
                class: "backbutton",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
              }, [
                _hoisted_2
              ]),
              _createVNode("div", _hoisted_3, [
                _createVNode("div", {
                  class: "nextButton likeButton active me-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.report()))
                }, [
                  _hoisted_4
                ]),
                _createVNode("div", {
                  class: "nextButton likeButton active",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.message()))
                }, [
                  _hoisted_5
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          _createVNode(_component_user_profile_image, {
            class: "profileImageRound",
            src: _ctx.$store.state.getUserImage(_ctx.profile.identifier)
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.profile.name), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", {
              innerHTML: _ctx.profile.description
            }, null, 8, ["innerHTML"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", {
              class: "numberBox genericShadow",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCommunityLiked()))
            }, [
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.profile.communityLiked), 1),
              _createVNode(_component_localized_text, {
                localizedKey: "app_communityseguite",
                text: "Community seguite",
                class: "fs_12 spaceCadet d-block ln_12 text-capitalize px-3"
              })
            ]),
            _createVNode("div", {
              class: "numberBox genericShadow",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openCommunityManaged()))
            }, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.profile.communityAdministrated), 1),
              _createVNode(_component_localized_text, {
                localizedKey: "app_communitygestite",
                text: "Community gestite",
                class: "fs_12 spaceCadet d-block ln_12 text-capitalize px-3"
              })
            ])
          ]),
          (_ctx.isSelf)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("div", {
                  class: "listButton genericShadow position-relative",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.info()))
                }, [
                  (!_ctx.$store.state.user.profileCompleted)
                    ? (_openBlock(), _createBlock("div", _hoisted_12))
                    : _createCommentVNode("", true),
                  _hoisted_13,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_aggiornainformazion",
                    text: "Aggiorna informazioni"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow position-relative",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.invitation()))
                }, [
                  (_ctx.hasNewInvitation)
                    ? (_openBlock(), _createBlock("div", _hoisted_14))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_invitirecenti",
                    text: "Inviti ricevuti"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.categories()))
                }, [
                  _hoisted_16,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_sceglicategoriediinteresse",
                    text: "Scegli categorie di interesse"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/usercalendar')))
                }, [
                  _hoisted_17,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_calendario",
                    text: "Calendario"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ordini()))
                }, [
                  _hoisted_18,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_imieiordini",
                    text: "I miei ordini"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePassword()))
                }, [
                  _hoisted_19,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_cambiapassword",
                    text: "Cambia password"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openUsersBlockedModal()))
                }, [
                  _hoisted_20,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_utentibloccati",
                    text: "Utenti bloccati"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.deleteUserModal()))
                }, [
                  _hoisted_21,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_eliminaAccount",
                    text: "Elimina Account"
                  })
                ]),
                _createVNode("div", {
                  class: "listButton genericShadow",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.logout()))
                }, [
                  _hoisted_22,
                  _createVNode(_component_localized_text, {
                    class: "fs_14 spaceCadet ms-3",
                    localizedKey: "app_logout",
                    text: "Logout"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
})